const getSliderAppearanceClass = sliderAppearance => {
    if('splitted' === sliderAppearance) {
        return ' splitted'
    } else if('slim_advertisement_slider' === sliderAppearance) {
        return ' slim'
    } else {
        return ''
    }
}

export default getSliderAppearanceClass